<template>
  <Modal
    :title="$t('global.securely-share-password')"
    @close="close"
    @confirm="confirm"
    size="large"
    :hide-footer="true"
  >
    <template #body>
      <ViewPasswordForm :password="data.password" :service="data.service" v-on="$listeners" />
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/display/Modal";
import ViewPasswordForm from "@/components/smart/forms/ViewPasswordForm";

export default {
  name: "ViewPasswordModal",
  components: {
    Modal,
    ViewPasswordForm,
  },
  props: {
    data: {
      type: Object,
      validator: (value) => {
        return !!value.password && typeof value.password === "object";
      },
    },
  },
  setup(props, { emit }) {
    const close = () => emit("close");
    const confirm = () => emit("confirm");

    return {
      close,
      confirm,
    };
  },
};
</script>
